import script from "./WritingOption.vue?vue&type=script&setup=true&lang=js"
export * from "./WritingOption.vue?vue&type=script&setup=true&lang=js"

import "./WritingOption.vue?vue&type=style&index=0&id=cef173fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cef173fa"]])

export default __exports__